import { formatPdfOutlineContexts, type ReadexPromptPDFOutlineContext } from './pdf-outline-prompt.ts';
import type { AcceptedConversationAttachment } from './attachments.ts';

/** Ported from ReadexUserPromptFormatter.swift's file and PDF-outline branches.
 * Keep headings, order, whitespace and the unmodified user request identical to
 * iPad. Names and paths must be resolved from the host's owned file catalog.
 * See docs/handoffs/pdf-prompt-parity.md for source provenance and scope. */
export interface ReadexPromptFileMention { displayName: string; path: string }

export function formatReadexUserPrompt(userPrompt: string, fileMentions: readonly ReadexPromptFileMention[] = [], pdfOutlineContexts: readonly ReadexPromptPDFOutlineContext[] = []): string {
  if (!fileMentions.length && !pdfOutlineContexts.length) return userPrompt;
  let formatted = '';
  if (fileMentions.length) {
    formatted += '\n# Files mentioned by the user:\n';
    for (const mention of fileMentions) formatted += `\n## ${mention.displayName}: ${mention.path}\n`;
  }
  if (pdfOutlineContexts.length) formatted += formatPdfOutlineContexts(pdfOutlineContexts);
  formatted += '\n## My request for Readex:\n';
  formatted += userPrompt;
  formatted += '\n';
  return formatted;
}

export function promptAttachmentMentions(attachments: readonly AcceptedConversationAttachment[]): ReadexPromptFileMention[] {
  return attachments.filter(item => item.kind !== 'pdf_outline_context').map(item => ({displayName:item.name,path:item.sandboxPath}));
}

export function promptAttachmentOutlineContexts(attachments: readonly AcceptedConversationAttachment[]): ReadexPromptPDFOutlineContext[] {
  return attachments.flatMap(item => item.kind === 'pdf_outline_context' && item.pdfOutlineContext ? [item.pdfOutlineContext] : []);
}
